import React, { useState, useEffect } from "react";
import { Form, Button, Dropdown } from "semantic-ui-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useAuth } from "../../../hook/userAuth";
import { ToastContainer, toast } from "react-toastify";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { map } from "lodash";

export function AddEditPeriodos(props) {
  const { onRefetch, periodo } = props;
  const { auth } = useAuth();
  const [cicloEscolar, setcicloEscolar] = useState(null);
  const [cicloEscolarFormato, setcicloEscolarFormato] = useState([]);
  const [refetch] = useState(false);

  async function getCicloEscolar() {
    try {
      const response = await axios.get(`${BASE_API}/api/ciclo_escolar/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const result = response.data;
      setcicloEscolar(result);
      return result;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getCicloEscolar();
    // eslint-disable-next-line
  }, [refetch]);

  useEffect(() => {
    setcicloEscolarFormato(formatoDelDropDown(cicloEscolar));
    // eslint-disable-next-line
  }, [cicloEscolar]);

  const formatFecha = (fecha) => {
    const opciones = { month: "long", year: "numeric" };
    const fechaFormateada = new Date(fecha).toLocaleDateString(
      "es-ES",
      opciones
    );
    return fechaFormateada;
  };

  function formatoDelDropDown(informacionCicloEscolar) {
    return map(informacionCicloEscolar, (item) => ({
      key: item.id_ciclo_escolar,
      text: `${formatFecha(item.fecha_inicio)} - ${formatFecha(
        item.fecha_fin
      )}`,
      value: item.id_ciclo_escolar,
    }));
  }

  // Arreglo de tipos de semestre
  const semesters = [
    { key: "A", text: "A (semestre impar)", value: "A" },
    { key: "B", text: "B (semestre par)", value: "B" },
  ];

  const addPeriodo = async (data) => {
    try {
      await createPeriodoApi(data, auth.token);
      toast.success("Período creado exitosamente");
    } catch (error) {
      throw error;
    }
  };

  const updatePeriodo = async (id, data) => {
    try {
      await updatePeriodoApi(id, data, auth.token);
      toast.success("Periodo actualizado exitosamente");
    } catch (error) {
      throw error;
    }
  };

  async function createPeriodoApi(data, token) {
    try {
      const url = `${BASE_API}/api/periodo/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.post(url, data, { headers });
      return response.data;
    } catch (error) {
      if (
        error.response &&
        (error.response.status === 400 || error.response.status === 500)
      ) {
        toast.error("El periodo ya existe");
      }
      throw error;
    }
  }

  async function updatePeriodoApi(id, data, token) {
    try {
      const url = `${BASE_API}/api/periodo/${id}/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.patch(url, data, { headers });
      return response.data;
    } catch (error) {
      if (
        error.response &&
        (error.response.status === 400) | (error.response.status === 500)
      ) {
        toast.error("El periodo ya existe");
      }
      throw error;
    }
  }

  const formik = useFormik({
    initialValues: initialValues(periodo),
    validationSchema: Yup.object(periodo ? updateSchema() : newSchema()),
    validateOnChange: false,
    onSubmit: async (formValue, { resetForm }) => {
      try {
        // Obtener los valores de las fechas
        const { fecha_inicio, fecha_fin } = formValue;
        // Formatear las fechas al formato "YYYY-MM-DD"
        const formattedFechaInicio = formatToISODate(fecha_inicio);
        const formattedFechaFin = formatToISODate(fecha_fin);
        // Crear el objeto de datos a enviar al servidor
        const dataToSend = {
          ...formValue,
          fecha_inicio: formattedFechaInicio,
          fecha_fin: formattedFechaFin,
        };

        if (periodo) {
          await updatePeriodo(periodo.id_periodo, dataToSend);
        } else {
          await addPeriodo(dataToSend);
          resetForm();
        }
        onRefetch();
      } catch (error) {
        console.error(error);
      }
    },
  });

  function formatToISODate(date) {
    if (!date) return null;
    const offset = date.getTimezoneOffset();
    const dateWithoutOffset = new Date(date.getTime() - offset * 60 * 1000);
    dateWithoutOffset.setDate(dateWithoutOffset.getDate() + 1);
    return dateWithoutOffset.toISOString().split("T")[0];
  }

  return (
    <>
      <div className="divcampo">
        <label className="campR">
          Campo requerido <span className="astedisco">*</span>
        </label>
      </div>
      <Form className="add-edit-user-form" onSubmit={formik.handleSubmit}>
        <div style={{ display: "flex" }}>
          <div style={{ width: "100%" }}>
            <label>Fecha inicio del periodo</label>
            <label className="astedisco">*</label>
            <div style={{ display: "flex", marginBottom: "1rem" }}>
              <div style={{ marginRight: "1rem", width: "100%" }}>
                <DatePicker
                  name="fecha_inicio"
                  placeholderText="dd/mm/aaaa"
                  selected={formik.values.fecha_inicio}
                  error={formik.errors.fecha_inicio}
                  onChange={(date) =>
                    formik.setFieldValue("fecha_inicio", date)
                  }
                  dateFormat="dd/MM/yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
            </div>
          </div>

          <div style={{ width: "100%" }}>
            <label>Fecha fin del periodo</label>
            <label className="astedisco">*</label>
            <div style={{ display: "flex", marginBottom: "1rem" }}>
              <div style={{ marginRight: "1rem", width: "100%" }}>
                <DatePicker
                  name="fecha_fin"
                  placeholderText="dd/mm/aaaa"
                  selected={formik.values.fecha_fin}
                  error={formik.errors.fecha_fin ? true : false}
                  onChange={(date) => formik.setFieldValue("fecha_fin", date)}
                  dateFormat="dd/MM/yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  className="form-control"
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <div style={{ width: "100%" }}>
            <div style={{ display: "flex", marginBottom: "1rem" }}>
              <div style={{ marginRight: "1rem", width: "50%" }}>
                <label>Tipo de semestre</label>
                <label className="astedisco">*</label>
                <Dropdown
                  placeholder="Seleccione el tipo de semestre"
                  fluid
                  selection
                  options={semesters}
                  name="tipo_semestre"
                  value={formik.values.tipo_semestre}
                  error={formik.errors.tipo_semestre ? true : false}
                  onChange={(e, { value }) =>
                    formik.setFieldValue("tipo_semestre", value)
                  }
                  style={{ width: "100%" }}
                />
              </div>
              <div style={{ marginRight: "1rem", width: "50%" }}>
                <label>Ciclo escolar</label>
                <label className="astedisco">*</label>
                <Dropdown
                  placeholder="Seleccione el ciclo escolar"
                  fluid
                  selection
                  options={cicloEscolarFormato}
                  name="Ciclo_escolar"
                  value={formik.values.Ciclo_escolar}
                  error={formik.errors.Ciclo_escolar ? true : false}
                  onChange={(e, { value }) =>
                    formik.setFieldValue("Ciclo_escolar", value)
                  }
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>
        <Button
          type="submit"
          content={periodo ? "Actualizar" : "Crear"}
          style={{ backgroundColor: "#008e86", color: "white", width: "100%" }}
          fluid
        />
      </Form>
      <ToastContainer />
    </>
  );

  function initialValues(datosPeriodo) {
    return {
      fecha_inicio: datosPeriodo?.fecha_inicio
        ? new Date(datosPeriodo.fecha_inicio)
        : null,
      fecha_fin: datosPeriodo?.fecha_fin
        ? new Date(datosPeriodo.fecha_fin)
        : null,
      tipo_semestre: datosPeriodo?.tipo_semestre || "",
      Ciclo_escolar: datosPeriodo?.Ciclo_escolar || "",
    };
  }
}
function newSchema() {
  return {
    fecha_inicio: Yup.date().required(),
    fecha_fin: Yup.date().required(),
    tipo_semestre: Yup.string().required(),
    Ciclo_escolar: Yup.string().required(),
  };
}

function updateSchema() {
  return {
    fecha_inicio: Yup.date().required(),
    fecha_fin: Yup.date().required(),
    tipo_semestre: Yup.string().required(),
    Ciclo_escolar: Yup.string().required(),
  };
}
